import { render } from "./Orcamento.vue?vue&type=template&id=a3e2c5a2"
import script from "./Orcamento.vue?vue&type=script&lang=ts"
export * from "./Orcamento.vue?vue&type=script&lang=ts"

import "./Orcamento.vue?vue&type=style&index=0&id=a3e2c5a2&lang=css"
script.render = render

export default script